import React, { Component } from 'react';
import './web-components-renderer.scss'
import PersonalProfile from '../PersonalProfile/PersonalProfile';
import DocuwareId from '../DocuwareId/DocuwareId';
import CompanyRelations from '../CompanyRelations/CompanyRelations';
import { Configuration } from '../../types/Configuration';

type State = {
    generalAreaHasError: boolean,
    accountAreaHasError: boolean,
    compRelAreaHasError: boolean
}

type Props = {
    accessToken: string,
    selectedLanguage: string,
    configuration: Configuration,
    tokenIsProvided: boolean
}

class WebComponenetsRenderer extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { generalAreaHasError: false, accountAreaHasError: false, compRelAreaHasError: false};
    }

    setGeneralAreaErrorState(generalAreaErrorState: boolean) {
        this.setState({ generalAreaHasError: generalAreaErrorState });
    }

    setAccountAreaErrorState(accountAreaErrorState: boolean) {
        this.setState({ accountAreaHasError: accountAreaErrorState });
    }

    setCompRelAreaErrorState(compRelAreaErrorState: boolean) {
        this.setState({ compRelAreaHasError: compRelAreaErrorState });
    }

 

    render() {
        const getClassGeneralArea = (hasError: boolean) => `component-container ${hasError ? "general-area error" : "general-area"}`;
        const getClassAccountArea = (hasError: boolean) => `component-container ${hasError ? "account-area error" : "account-area"}`;
        return (
            <div>
                <div id="GeneralArea" className={getClassGeneralArea(this.state.generalAreaHasError)}>
                    <PersonalProfile {... this.props}
                        onLoadCallback={() => this.setGeneralAreaErrorState(false)}
                        onErrorCallback={() => this.setGeneralAreaErrorState(true)}>
                    </PersonalProfile>
                </div>
                <div id="AccountArea" className={getClassAccountArea(this.state.accountAreaHasError)}>
                    <DocuwareId {... this.props}
                        onLoadCallback={() => this.setAccountAreaErrorState(false)}
                        onErrorCallback={() => this.setAccountAreaErrorState(true)}>
                    </DocuwareId>
                </div>
                <div id="CompRelArea" className={getClassAccountArea(this.state.compRelAreaHasError)}>
                    <CompanyRelations {... this.props}
                        onLoadCallback={() => this.setCompRelAreaErrorState(false)}
                        onErrorCallback={() => this.setCompRelAreaErrorState(true)}>
                    </CompanyRelations>
                </div>
                <div id="sticky-break"></div>
            </div>
        )
    }
}

export default WebComponenetsRenderer;